export const APP_RECAPTCHA_SITE_KEY = process.env['NEXT_PUBLIC_APP_RECAPTCHA_SITE_KEY'] ?? '';
export const APP_RECAPTCHA_API_URL = `${process.env['NEXT_PUBLIC_APP_RECAPTCHA_API_URL'] ?? ''}?trustedtypes=true&render=${APP_RECAPTCHA_SITE_KEY}`;
